import { Link } from 'react-router-dom';
import logoFooter from '../../assets/logo_footer.png';

const Footer = () => {
  return (
    <footer className="bg-bgreen">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="rounded-lg">
                <img
                  src={logoFooter}
                  alt="BEA Logo"
                  className="h-16 w-auto object-contain"
                />
              </div>
            </div>
            <p className="text-white/55 text-sm leading-relaxed mb-5 max-w-xs">
              Bihar Ethanol Association — the unified voice for Bihar&apos;s ethanol ecosystem, bridging industry, government, and energy.
            </p>
            <div className="flex items-center gap-3">
              {[
                { label: 'Facebook', icon: 'ri-facebook-fill', href: 'https://www.facebook.com/biharethanol', color: 'bg-[#1877F2]/20 text-white hover:bg-[#1877F2] border-[#1877F2]/40' },
                { label: 'LinkedIn', icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/company/biharethanol/', color: 'bg-[#0A66C2]/20 text-white hover:bg-[#0A66C2] border-[#0A66C2]/40' },
                { label: 'X (Twitter)', icon: 'ri-twitter-x-fill', href: 'https://x.com/biharethanol', color: 'bg-white/10 text-white hover:bg-white hover:text-black border-white/30' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className={`w-10 h-10 rounded-xl border flex items-center justify-center transition-all duration-200 cursor-pointer shadow-2xs hover:scale-105 ${s.color}`}
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {/* About */}
          <div>
            <h4 id="footer-about" className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4">
              <a href="#footer-about">About Us</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'About BEA', path: '/about' },
                { label: 'Mission & Vision', path: '/about#mission' },
                { label: 'Objectives', path: '/about#objectives' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-white/55 hover:text-white text-sm transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 id="footer-resources" className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4">
              <a href="#footer-resources">Resources</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Ethanol Ecosystem', path: '/ecosystem' },
                { label: 'Knowledge Hub', path: '/knowledge' },
                { label: 'OMC Tenders', path: '/tenders' },
                { label: 'BEA Represent', path: '/represent' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-white/55 hover:text-white text-sm transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 id="footer-contact" className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4">
              <a href="#footer-contact">Contact Us</a>
            </h4>
            <ul className="space-y-3 text-xs sm:text-sm">
              <li className="flex items-start gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-byellow text-sm" />
                </span>
                <a
                  href="https://maps.app.goo.gl/7uka9T8jwwKWX4Uz8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/55 hover:text-white leading-snug transition-colors"
                >
                  C-0503, City Centre Mall, Opposite Fire Station, Buddh Marg, Patna &ndash; 800001
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-smartphone-line text-byellow text-sm" />
                </span>
                <span className="text-white/55">+91 62012 70234</span>
              </li>
              <li className="flex items-center gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-byellow text-sm" />
                </span>
                <span className="text-white/55">+91 612 2330122</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-byellow text-sm" />
                </span>
                <div className="flex flex-col">
                  <a href="mailto:ethanolassociationbihar@gmail.com" className="text-white/55 hover:text-white truncate transition-colors">
                    ethanolassociationbihar@gmail.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
          <p className="text-white/35">
            &copy; {new Date().getFullYear()} Bihar Ethanol Association. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <button
              onClick={() => window.dispatchEvent(new Event('open-bea-advisory'))}
              className="text-byellow hover:text-white text-xs font-semibold transition-colors cursor-pointer flex items-center gap-1"
            >
              <i className="ri-megaphone-line text-xs" />
              <span>Media Advisory (E20)</span>
            </button>
            <a href="#" className="text-white/35 hover:text-white/70 text-xs transition-colors cursor-pointer" rel="nofollow">Privacy Policy</a>
            <a href="#" className="text-white/35 hover:text-white/70 text-xs transition-colors cursor-pointer" rel="nofollow">Terms of Use</a>
          </div>
        </div>
      </div>

      {/* Separate credit bar from the website's footer */}
      <div className="bg-black/20 border-t border-white/10 px-6 md:px-10 py-1.5">
        <div className="max-w-7xl mx-auto flex justify-end">
          <p className="text-[9.5px] text-white/40 tracking-wide">
            Developed and Maintained by{' '}
            <a
              href="https://avinyaresearch.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-byellow transition-colors underline decoration-white/20 hover:decoration-byellow font-medium"
            >
              AVINYA RESEARCH LABS
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
